import { Capacitor } from '@capacitor/core';
import { set, get, del, clear as idbClear } from 'idb-keyval';
import {
  clearSQLite,
  createSQLiteTable,
  getSQLiteItem,
  removeSQLiteItem,
  setSQLiteItem,
} from './sqlite';
import { PermanentDataStoreKey } from './storage.types';

type PermanentDataStoreType = {
  initialize: () => Promise<void>;
  getItem: <T>(key: PermanentDataStoreKey) => Promise<T | undefined>;
  setItem: <T>(key: PermanentDataStoreKey, value: T) => Promise<void>;
  removeItem: (key: PermanentDataStoreKey) => Promise<void>;
  clear: () => Promise<void>;
};

const WebPermanentDataStore: PermanentDataStoreType = {
  initialize: () => Promise.resolve(), // no-op for web
  setItem: set,
  getItem: get,
  removeItem: del,
  clear: idbClear,
};

const NativePermanentDataStore: PermanentDataStoreType = {
  initialize: createSQLiteTable,
  setItem: setSQLiteItem,
  getItem: getSQLiteItem,
  removeItem: removeSQLiteItem,
  clear: clearSQLite,
};

export const PermanentDataStore = Capacitor.isNativePlatform()
  ? NativePermanentDataStore
  : WebPermanentDataStore;
